"use strict";

var onValue = function (data) {
    const This = this;
    var lastState = This._state.onValue;
    var newState = JSON.stringify(data);
    if (lastState == newState) {
        return;
    }
    This._state.onValue = newState;
    return This._listener.onValue.apply(This._listener, arguments);
};

var onChildAdded = function (key, value) {
    const This = this;
    var newState = JSON.stringify(value);
    This._state.onChild[key] = newState;
    return This._listener.onChildAdded.apply(This._listener, arguments);
};

var onChildChanged = function (key, value) {
    const This = this;
    var lastState = This._state.onChild[key];
    var newState = JSON.stringify(value);
    if (lastState == newState) {
        return;
    }
    This._state.onChild[key] = newState;
    return This._listener.onChildChanged.apply(This._listener, arguments);
};

var onChildRemoved = function (key, value) {
    const This = this;
    delete This._state.onChild[key];
    return This._listener.onChildChanged.apply(This._listener, arguments);
};

export default function (listener) {
    var This = Object.create(listener);

    This._listener = listener;
    This._state = {
        onValue: undefined,
        onChild: {}
    };
    if (listener.onValue) {
        This.onValue = onValue.bind(This);
    }

    if (listener.onChildChanged) {
        This.onChildAdded = onChildAdded.bind(This);
        This.onChildChanged = onChildChanged.bind(This);
        This.onChildRemoved = onChildRemoved.bind(This);
    }

    return This;
};

